const toSafeString = (value) => String(value || "").trim();

const isCustomerOrClient = (roleName) => {
  const normalized = toSafeString(roleName).toLowerCase();
  return normalized.includes("customer") || normalized.includes("client");
};

const buildDppApiUrl = ({ baseUrl, route, dppId, roleName, basePath = "/dpp/main_api", useCustomerPrefix = true }) => {
  const normalizedBaseUrl = toSafeString(baseUrl).replace(/\/+$/, "");
  const normalizedRoute = toSafeString(route).replace(/^\/+/, "");
  const customerPrefix = useCustomerPrefix && isCustomerOrClient(roleName) ? "customer/" : "";
  return `${normalizedBaseUrl}${basePath}/${customerPrefix}${normalizedRoute}?dppId=${encodeURIComponent(toSafeString(dppId))}`;
};

const getJsonResponse = async (url, jwtToken) => {
  const headers = {
    "Content-Type": "application/json",
  };

  if (toSafeString(jwtToken)) {
    headers.Authorization = `Bearer ${toSafeString(jwtToken)}`;
  }

  const response = await fetch(url, {
    method: "GET",
    headers,
  });

  if (!response.ok) {
    const bodyText = await response.text();
    throw new Error(`Request failed ${response.status}: ${bodyText}`);
  }

  return response.json();
};

const sidebarResponseCache = new Map();
const documentUrlCache = new Map();

export const fetchDppSection = async ({
  baseUrl,
  roleName,
  route,
  dppId,
  jwtToken,
  useCustomerPrefix = true,
  basePath = "/dpp/main_api",
}) => {
  const requestKey = `${toSafeString(baseUrl)}|${toSafeString(roleName)}|${basePath}|${toSafeString(route)}|${toSafeString(dppId)}`;
  if (sidebarResponseCache.has(requestKey)) {
    return sidebarResponseCache.get(requestKey);
  }

  const apiUrl = buildDppApiUrl({ baseUrl, roleName, route, dppId, basePath, useCustomerPrefix });
  const json = await getJsonResponse(apiUrl, jwtToken);
  sidebarResponseCache.set(requestKey, json);
  return json;
};

export const fetchDppDocumentUrl = async ({ baseUrl, moduleName, name, type }) => {
  if (!moduleName || !name || !type) {
    throw new Error("Missing document parameters");
  }

  const requestKey = `${toSafeString(baseUrl)}|${toSafeString(moduleName)}|${toSafeString(name)}|${toSafeString(type)}`;
  if (documentUrlCache.has(requestKey)) {
    return documentUrlCache.get(requestKey);
  }

  const apiUrl = `${toSafeString(baseUrl)}/dpp/s3_documents?moduleName=${encodeURIComponent(
    toSafeString(moduleName),
  )}&name=${encodeURIComponent(toSafeString(name))}&type=${encodeURIComponent(toSafeString(type))}`;

  const json = await getJsonResponse(apiUrl, "");
  documentUrlCache.set(requestKey, json);
  return json;
};

export const clearDppSectionCache = () => {
  sidebarResponseCache.clear();
  documentUrlCache.clear();
};
